import Auslage from './auslage'
import Person from './person'
import md5 from 'md5'
import User from '../User/user'
import Bank from '../User/bank'
import Reisekosten from './Reisekosten/reisekosten'
import Abrechnung from './abrechnung_v2'
import Adresse from '../User/adresse'
import { collection, doc, getDoc, getDocs, getFirestore, onSnapshot, query, where } from 'firebase/firestore'
import Beleg from './Kosten/beleg'
import Tagegeld from './Reisekosten/tagegeldReisekosten'
import TagegeldTag from './Reisekosten/tagegeldTag'
import Ausgabe from './Kosten/ausgabe'
import Fahrtkosten from './Reisekosten_v2/fahrtkosten'

class Reisekostenabrechnung extends Abrechnung {

    kilometersatz = 0.3

    constructor(
        id,
        versionId,
        empfaenger,
        abrechnender,
        reisezweck = '',
        reise_angeordnet = '',
        reisebeginn = {
            datum: '',
            uhrzeit: '17:00'
        },
        reiseende = {
            datum: '',
            uhrzeit: '19:00'
        },
        reisestart = new Adresse(),
        reiseziel = new Adresse(),
        wegpunkte = [],
        routetype = 'Start/Ziel',
        fahrtkosten = {
            pkw: {
                active: false,
                calculated: true,
                begruendung: '',
                kilometer: 0,
                summe: 0,
                kennzeichen: ''
            },
            opnv: {
                active: false,
                summe: 0,
                belege: []
            },
            taxi: {
                active: false,
                summe: 0,
                belege: []
            }
        },
        ausgaben = [],
        auslagen = {
            active: false,
            hauptamt: false,
            tage: 0,
            satz: 0,
            summe: 0
        },
        uebernachtungsgelder = {
            active: false,
            anzahl: 0,
            betrag: 0,
            summe: 0
        },
        status = 'Neu',
        freigaben = [],
        historie = [],
        anmerkungen = '',
        kostenstelle = [],
        kostentraeger = [],
        printed = false,
        kreditorennummer = '',
        tags = []
    ) {

        super(id, versionId, empfaenger, abrechnender, [], ausgaben, [], status, freigaben, '', 'Reisekostenabrechnung', historie, anmerkungen, kostenstelle, kostentraeger, printed, kreditorennummer, tags)

        this.reisezweck = reisezweck
        this.reise_angeordnet = reise_angeordnet
        this.reisebeginn = reisebeginn
        this.reiseende = reiseende
        this.reisestart = reisestart instanceof Adresse ? reisestart : new Adresse(reisestart.strasse, reisestart.nr, reisestart.plz, reisestart.ort, reisestart.additionalName)
        this.reiseziel = reiseziel instanceof Adresse ? reiseziel : new Adresse(reiseziel.strasse, reiseziel.nr, reiseziel.plz, reiseziel.ort, reiseziel.additionalName)
        this.wegpunkte = Array.isArray(wegpunkte) ? wegpunkte.map(item => {
            return new Adresse(item.strasse, item.nr, item.plz, item.ort)
        }) : []
        this.routetype = routetype || 'Start/Ziel'
        this.fahrtkosten = new Fahrtkosten(
            fahrtkosten?.pkw,
            fahrtkosten?.opnv,
            fahrtkosten?.taxi
        )
        this.auslagen = new Tagegeld(auslagen?.active, auslagen?.tage, auslagen?.satz, auslagen?.summe, auslagen?.calculated)
        this.uebernachtungsgelder = uebernachtungsgelder

        this.kostenstelle = kostenstelle
        this.kostentraeger = kostentraeger

        //Initiales Laden der Belege
        this.belege = []
        this.get_belege(false)

        this.printed = printed
    }

    valid() {
        if (this.fahrtkosten.opnv.active && this.fahrtkosten.opnv.belege.length == 0) {
            return false
        }
        if (this.fahrtkosten.taxi.active && this.fahrtkosten.taxi.belege.length == 0) {
            return false
        }
        if(!this.fahrtkosten.pkw.active && !this.fahrtkosten.opnv.active && !this.fahrtkosten.taxi.active) {
            return false
        }
        return true
    }

    get_belege(onSnap = true) {
        const belegeRef = collection(getFirestore(), 'Abrechnungen/' + this.id + '/Belege')
        if (onSnap) {
            const queryRef = query(belegeRef, where('url', '!=', 'Test'))
            this.belegeSnap = onSnapshot(queryRef, snap => {
                this.belege = []
                snap.forEach(beleg => {
                    this.belege.push(new Beleg(beleg.id, this.id, beleg.data().filename, beleg.data().name, beleg.data().beschreibung, beleg.data().url, beleg.data().type))
                })
            })
        }
        else {
            getDocs(belegeRef).then(snap => {
                this.belege = []
                snap.forEach(beleg => {
                    this.belege.push(new Beleg(beleg.id, this.id, beleg.data().filename, beleg.data().name, beleg.data().beschreibung, beleg.data().url, beleg.data().type))
                })
            })
        }
    }

    async setAbrechnender(abrechnender) {
        if (abrechnender instanceof User) {
            this.abrechnender = abrechnender
        }
        else {
            this.abrechnender = new User(
                abrechnender?.id,
                '',
                abrechnender?.vorname,
                abrechnender?.nachname,
                abrechnender?.email,
                abrechnender?.funktionen,
                abrechnender?.adresse,
                abrechnender?.bank instanceof Bank ? new Bank(abrechnender.bank.phrase, abrechnender.bank.toFirestore()) : new Bank(abrechnender?.customFields?.phrase, abrechnender?.bank),
                abrechnender?.bank_last_changed,
                '',
                {
                    phrase: abrechnender?.customFields?.phrase
                },
                abrechnender?.kreditorennummer,
                [],
                '',
                '',
                [],
                abrechnender?.kfz_kennzeichen,
                [],
                false,
                false,
                abrechnender?.kreditorennummer_verband
            )

            if (!this.abrechnender.kreditorennummer) {
                const userDoc = await getDoc(doc(getFirestore(), 'User/' + this.abrechnender.id))
                if (userDoc.exists()) {
                    this.abrechnender.kreditorennummer = userDoc.data().kreditorennummer
                }
            }
        }

    }

    calcAuslagensumme() {
        this.auslagen.summe = (parseFloat(this.auslagen.tage) * parseFloat(this.auslagen.satz)).toFixed(2)
    }

    calcUebernachtungensumme() {
        this.uebernachtungsgelder.betrag = parseFloat(this.uebernachtungsgelder.betrag).toFixed(2)
        this.uebernachtungsgelder.summe = (parseFloat(this.uebernachtungsgelder.anzahl) * parseFloat(this.uebernachtungsgelder.betrag)).toFixed(2)
    }

    calcFahrtkostenPKWSumme() {
        this.fahrtkosten.pkw.calculateSumme()
    }

    getNebenkostenSumme() {
        var summe = 0
        this.ausgaben.forEach(item => {
            summe += parseFloat(item.kosten)
        })
        return parseFloat(summe).toFixed(2)
    }

    calculateTage() {
        var start, ende, dauer
        this.auslagen.calculated.tage = []
        if (this.reisebeginn.datum == this.reiseende.datum) {
            this.auslagen.calculated.active = true
            start = this.reisebeginn.uhrzeit.split(':')
            ende = this.reiseende.uhrzeit.split(':')
            dauer = Math.round(parseInt(ende[0]) - parseInt(start[0])) + ((parseInt(ende[1]) - parseInt(start[1])) / 60)
            this.auslagen.calculated.tage.push(
                new TagegeldTag(this.reisebeginn.datum, dauer, 0)
            )
        }
        else {
            this.auslagen.calculated.active = true
            var startDate = new Date(this.reisebeginn.datum)
            var endDate = new Date(this.reiseende.datum)
            var date = new Date(this.reisebeginn.datum)
            while (date.getTime() <= endDate.getTime()) {
                if (date.getTime() == startDate.getTime()) {
                    start = this.reisebeginn.uhrzeit.split(':')
                    ende = '24:00'.split(':')
                    dauer = Math.round(parseInt(ende[0]) - parseInt(start[0])) + ((parseInt(ende[1]) - parseInt(start[1])) / 60)
                    this.auslagen.calculated.tage.push(
                        new TagegeldTag(this.reisebeginn.datum, dauer, 0)
                    )
                }
                else if (date.getTime() == endDate.getTime()) {
                    start = '00:00'.split(':')
                    ende = this.reiseende.uhrzeit.split(':')
                    dauer = Math.round(parseInt(ende[0]) - parseInt(start[0])) + ((parseInt(ende[1]) - parseInt(start[1])) / 60)
                    this.auslagen.calculated.tage.push(
                        new TagegeldTag(this.reiseende.datum, dauer, 0)
                    )
                }
                else {
                    this.auslagen.calculated.tage.push(
                        new TagegeldTag(date.toJSON().split('T')[0], 24, 0)
                    )
                }
                date.setDate(date.getDate() + 1)
            }
        }
        this.auslagen.calculateSumme()
    }

    fahrtkostensumme() {
         var summe = 0
        if (this.fahrtkosten.pkw.active) {
            summe += parseFloat(this.fahrtkosten.pkw.summe)
        }
        if (this.fahrtkosten.opnv.active) {
            summe += parseFloat(this.fahrtkosten.opnv.summe)
        }
        if (this.fahrtkosten.taxi.active) {
            summe += parseFloat(this.fahrtkosten.taxi.summe)
        }
        return parseFloat(summe).toFixed(2)
    }

    tagegeldersumme() {
         var summe = 0
        if (this.auslagen.active && this.auslagen.calculated.active) {
            summe += parseFloat(this.auslagen.calculated.summe)
        }
        else if (this.auslagen.active && !this.auslagen.calculated.active) {
            summe += parseFloat(this.auslagen.summe)
        }
        return parseFloat(summe).toFixed(2)
    }

    uebernachtungsgeldersumme() {
        var summe = 0
        if (this.uebernachtungsgelder.active) {
            summe += parseFloat(this.uebernachtungsgelder.summe)
        }
        return parseFloat(summe).toFixed(2)
    }

    gesamtsumme() {
        var summe = 0
        summe += parseFloat(this.fahrtkostensumme())
        summe += parseFloat(this.tagegeldersumme())
        summe += parseFloat(this.uebernachtungsgeldersumme())
        summe += parseFloat(this.getNebenkostenSumme())

        return parseFloat(summe).toFixed(2)
    }

    toFirestore() {
        return {
            id: this.id,
            versionId: this.versionId,
            empfaenger: this.empfaenger,
            abrechnender: Object.assign({ customFields: this.abrechnender.customFields }, this.abrechnender.toFirestore()),
            reisezweck: this.reisezweck,
            reise_angeordnet: this.reise_angeordnet,
            reisebeginn: this.reisebeginn,
            reiseende: this.reiseende,
            reisestart: this.reisestart.toFirestore(),
            reiseziel: this.reiseziel.toFirestore(),
            wegpunkte: this.wegpunkte.map(item => {
                return item.toFirestore()
            }),
            routetype: this.routetype,
            fahrtkosten: this.fahrtkosten.toFirestore(),
            auslagen: this.auslagen.toFirestore(),
            uebernachtungsgelder: this.uebernachtungsgelder,
            ausgaben: this.ausgaben.map(item => {
                return item.toFirestore()
            }),
            freigaben: this.freigaben,
            type: this.type,
            status: this.status,
            historie: this.historie,
            anmerkungen: this.anmerkungen,
            kostenstelle: this.kostenstelle,
            kostentraeger: this.kostentraeger,
            printed: this.printed,
            kreditorennummer: this.kreditorennummer || '',
            tags: this.tags,
            v2: true
        }
    }
}

export default Reisekostenabrechnung